(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-testimonials-carousel"]) return;
  try {
    
(function(){
  function initAlohaReviews(root){
    var sections=(root||document).querySelectorAll('[data-aloha-reviews]:not([data-aloha-reviews-ready])');
    sections.forEach(function(section){
      section.setAttribute('data-aloha-reviews-ready','true');
      var viewport=section.querySelector('[data-aloha-review-viewport]');
      var prev=section.querySelector('[data-aloha-review-prev]');
      var next=section.querySelector('[data-aloha-review-next]');
      if(viewport&&prev&&next){
        var move=function(direction){
          var card=viewport.querySelector('.aloha-testimonials__card');
          if(!card){return;}
          var track=viewport.querySelector('.aloha-testimonials__track');
          var gap=parseFloat(window.getComputedStyle(track).gap)||12;
          viewport.scrollBy({left:direction*(card.getBoundingClientRect().width+gap),behavior:'smooth'});
        };
        prev.addEventListener('click',function(){move(-1);});
        next.addEventListener('click',function(){move(1);});
      }
      var submit=section.querySelector('.aloha-testimonials__submit');
      if(submit&&(submit.querySelector('.aloha-testimonials__success')||submit.querySelector('.errors'))){
        submit.open=true;
      }
    });
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){initAlohaReviews(document);});
  }else{
    initAlohaReviews(document);
  }
  document.addEventListener('shopify:section:load',function(event){initAlohaReviews(event.target);});
})();

  } catch(e) { console.error(e); }
})();
})();
